export default __webpack_public_path__ + "static/hover11-6af33099b9ba1a1528ebbf089fecd754.png";